import { render } from "./add-contact-list-modal.vue?vue&type=template&id=2e27a8a1"
import script from "./add-contact-list-modal.vue?vue&type=script&lang=js"
export * from "./add-contact-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__